import { addZero } from '../addZero';
import { months, days } from '../../const/dateOptions';

export const formatDateLk = ({ day, month, year }: { day: number; month: number; year: number }): string => {
  if (day > 31) {
    throw new Error('чисел больше 31');
  }
  if (month > 12) {
    throw new Error('месяцев больше 12');
  }
  if (year < 0) {
    throw new Error('год меньше 0');
  }
  return `${addZero(day)} ${months[month - 1]} ${year}`;
};

export const formatDayWeek = date => {
  if (date) {
    const parts = date.split(' ');
    const day = parseInt(parts[0], 10);
    const monthIndex = months.indexOf(parts[1]);
    const year = parseInt(parts[2], 10);
    const newDate = new Date(year, monthIndex, day);
    return days[newDate?.getDay()];
  }
};

export const stringToDate = (value: string): Date => {
  // Создаем регулярное выражение для парсинга строки даты
  const regex = /(?<day>\d{2}) (?<month>[а-я]+) (?<year>\d{4}) г\./i;
  const match = regex.exec(value);

  if (!match) {
    throw new Error('Invalid date string');
  }

  const { day, month, year } = match.groups as { day: string; month: string; year: string };

  // Преобразование названия месяца в числовой индекс
  const monthIndex = months.indexOf(month.toLowerCase());
  if (monthIndex === -1) {
    throw new Error('Invalid month name');
  }

  return new Date(parseInt(year), monthIndex, parseInt(day));
};

export function isTimeExpired(date: Date): boolean {
  const currentDate = new Date();
  // Обнулим время в обоих датах для точного сравнения только по дню
  currentDate.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date <= currentDate;
}

export const parseDate = dateString => {
  const months = {
    января: 0,
    февраля: 1,
    марта: 2,
    апреля: 3,
    мая: 4,
    июня: 5,
    июля: 6,
    августа: 7,
    сентября: 8,
    октября: 9,
    ноября: 10,
    декабря: 11,
  };

  const parts = dateString.split(' ');
  const day = parseInt(parts[0], 10);
  const month = months[parts[1]];
  const year = parseInt(parts[2], 10);

  return new Date(year, month, day);
};
